module.exports = __webpack_public_path__ + "static/media/particle-top.fcdc4cc3.svg";